import { ApolloLink } from '@apollo/client'

const ALLOWED_COOKIES = ['access_token']

export const cookieLink = new ApolloLink((operation, forward) => {
  const cookies = document.cookie.split(';')

  const filteredCookies = cookies
    .map(cookie => cookie.trim())
    .filter(cookie => {
      const [name] = cookie.split('=')
      return ALLOWED_COOKIES.includes(name)
    })
    .join('; ')

  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      cookie: filteredCookies
    }
  }))

  return forward(operation)
})
